import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";

export const RecurrenceTypes = ['daily', 'weekly', 'monthly'] as const;
export type RecurrenceTypes = typeof RecurrenceTypes[any];


export const DaysList = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type DaysList = typeof DaysList[number];

export const MonthList = (Array.from({ length: 31 }, (_, i) => i + 1)) as any;
export type MonthList = typeof MonthList[number];

export function scheduleGroup(data?: any): FormGroup {
   const fg = new FormGroup({
      id: new FormControl(data?.id || ''),
      schedule_name: new FormControl(data?.schedule_name || '',[Validators.pattern(/^(?!\s*$).+/)]),
      schedule_description: new FormControl(data?.schedule_description || ''),
      active: new FormControl(data?.active || false),
      recurrence_period: new FormControl(data?.recurrence_period || ''),
      startTime: new FormControl(data?.startTime || ''),
      startDate: new FormControl(data?.startDate || ''),
      endDate: new FormControl(data?.endDate || ''),
      no_end_date: new FormControl(data?.no_end_date || false),
      frequency_week: new FormControl(data?.frequency_week || []),
      frequency_month: new FormControl(data?.frequency_month || []),
      timezone: new FormControl(data?.timezone || ''),
      recipients: recArray(data?.recipients)
   });

   return fg;
}

function recArray(recipients: any[] = []): FormArray {
   const recs = new FormArray([]);
   recipients
      .filter(r => r['recipient_name'] || r['recipient_email'])
      .map(r => { recs.push(recGroup(r)) });

   return recs;
}

function recGroup(rec: any): FormGroup {
   return new FormGroup({
      recipient_name: new FormControl(rec.recipient_name),
      recipient_email: new FormControl(rec.recipient_email),
   })
}

export interface IScheduleReport {

   id: string;
   schedule_name: string;
   schedule_description: string;
   active: boolean;
   recurrence_period: any;
   startTime: string;
   startDate: string;
   endDate: string;
   no_end_date: boolean;
   frequency_week: number[];
   frequency_month: number[];
   timezone: string;
   recipients: any;
   report_name:string;
}

export class ScheduleReport implements IScheduleReport {
   id: string;
   schedule_name: string;
   schedule_description: string;
   active: boolean;
   recurrence_period: any;
   startTime: string;
   startDate: string;
   endDate: string;
   no_end_date: boolean;
   frequency_week: number[];
   frequency_month: number[];
   timezone: string;
   recipients: any;
   report_name:string;

   constructor(sr?: any) {
      this.id = sr.id;
      this.schedule_name = sr.schedule_name;
      this.schedule_description = sr.schedule_description;
      this.active = sr.status
      this.recurrence_period = sr.recurrence_period;
      this.startTime = sr.startTime;
      this.startDate = sr.startDate;
      this.endDate = sr.endDate;
      this.no_end_date = sr.no_end_date;
      this.frequency_week = sr.frequency_week;
      this.frequency_month = sr.frequency_month;
      this.timezone = sr.timezone;
      this.recipients = sr.recipients;
      this.report_name = sr.report_name;
   }
}

// export class DefaultScheduleReport implements ScheduleReport {
//    id: string;
//    schedule_name: string;
//    schedule_description: string;
//    status: boolean;
//    recurrence_period: string;
//    startTime: string;
//    startDate: string;
//    endDate: string;
//    no_end_date: boolean;
//    frequency_week: number[];
//    frequency_month: number[];
//    timezone: string;
//    recipients: any;

//    constructor(sr?: any) {
//       this.id = '336';
//       this.schedule_name = 'test Name';
//       this.schedule_description = 'description';
//       this.status = true;
//       this.recurrence_period = 'monthly';
//       this.startTime = sr.startTime;
//       this.startDate = "Mon May 06 2025 19:04:27 GMT+0800 (Philippine Standard Time)";
//       this.endDate = "Mon May 06 2027 19:04:27 GMT+0800 (Philippine Standard Time)";
//       this.no_end_date = false;
//       this.frequency_week = [0, 3, 5];
//       this.frequency_month = [1, 2, 3, 14, 17, 25, 28];
//       this.timezone = "Europe/London";
//       this.recipients = [{
//          recipient_email: "tadashi.tomaszewski622@chello.name",
//          recipient_name: "Claúdia Svoboda"
//       }];
//    }

// }